import styled from '@emotion/styled';
import { Alert } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { SURVEYS } from '@hotjar/webapp/constants/routes';
import { useCurrentSiteId } from '@hotjar/site';
import type { Survey } from '@hotjar/feedback';

const AlertWrapper = styled.div`
  margin: 0 30px 20px;
`;

const getCopyRoute = (siteId: string, copyId: Survey['id']) => {
  return getRoute(SURVEYS.CREATE.path, { siteId, copyId });
};

export interface ResponsesCollectedAlertProps {
  mode: 'create' | 'edit';
  responseCount: Survey['response_count'] | undefined;
  surveyId: Survey['id'] | undefined;
  widgetType: 'widget' | 'survey';
}

export const ResponsesCollectedAlert = ({
  mode,
  responseCount = 0,
  surveyId,
  widgetType,
}: ResponsesCollectedAlertProps): JSX.Element | null => {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.alerts.collected-responses' });
  const currentSiteId = useCurrentSiteId();
  const shouldRenderAlert =
    mode === 'edit' && currentSiteId !== null && surveyId !== undefined && responseCount > 0;
  return shouldRenderAlert ? (
    <AlertWrapper>
      <Alert
        kind="warning"
        title={t('title', { responses: responseCount, widgetType })}
        actionText={t('action')}
        actionHref={getCopyRoute(currentSiteId, surveyId)}
      >
        {t('message')}
      </Alert>
    </AlertWrapper>
  ) : null;
};
